import { render, staticRenderFns } from "./Addredit.vue?vue&type=template&id=0671ee67&scoped=true&"
import script from "./Addredit.vue?vue&type=script&lang=js&"
export * from "./Addredit.vue?vue&type=script&lang=js&"
import style0 from "./Addredit.vue?vue&type=style&index=0&id=0671ee67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0671ee67",
  null
  
)

export default component.exports